export enum InvoiceDocumentFormat {
    Pdf = 'Pdf',
    XRechnungXml = 'XRechnungXml',
    ZugferdXml = 'ZugferdXml',
    EdifactInvoicD07A = 'EdifactInvoicD07A',
    VolkswagenVda4938T2 = 'VolkswagenVda4938T2',
}

export const invoiceDocumentFormatLabels: Record<InvoiceDocumentFormat, string> = {
    [InvoiceDocumentFormat.Pdf]: 'PDF',
    [InvoiceDocumentFormat.XRechnungXml]: 'XRechnung XML',
    [InvoiceDocumentFormat.ZugferdXml]: 'ZUGFeRD XML',
    [InvoiceDocumentFormat.EdifactInvoicD07A]: 'EDIFACT INVOIC D.07A',
    [InvoiceDocumentFormat.VolkswagenVda4938T2]: 'Volkswagen VDA 4938 T2',
};

export const invoiceStructuredFormats: InvoiceDocumentFormat[] = [
    InvoiceDocumentFormat.XRechnungXml,
    InvoiceDocumentFormat.ZugferdXml,
    InvoiceDocumentFormat.EdifactInvoicD07A,
    InvoiceDocumentFormat.VolkswagenVda4938T2,
];
